export default __webpack_public_path__ + "static/media/discord-logo.023684f9.svg";